import React, { useState } from "react";
import experiences from "../../common/data/experiences/experiences";
import styles from './JobExperience.module.css';
import Job from "../Job/Job";

const JobExperience = () => {
    const [ selectedJob, setSelectedJob ] = useState(experiences[0]);

    function handleSelectedJob(e, exp) {
        setSelectedJob(exp);
    }

    return (
        <div id="experience" className={styles.container}>
            <h2 className={styles.header}>02. Experience</h2>
            <div className={styles.jobsContainer}>
                <ul className={styles.jobNamesContainer}>
                    {
                        experiences.map(exp => (
                            <li key={exp.company}>
                                <button 
                                    onClick={(e) => handleSelectedJob(e, exp)}
                                    className={
                                        `${styles.company} 
                                        ${selectedJob.company === exp.company ? styles.selectedCompany : null}`
                                    }
                                >
                                    {exp.company}
                                </button>
                            </li>
                        ))
                    }
                </ul>
                <div>
                    <Job
                        key={selectedJob.id}
                        company={selectedJob.company} 
                        link={selectedJob.link}
                        period={selectedJob.period}
                        title={selectedJob.title}
                        description={selectedJob.description}
                    />
                </div>
            </div>
        </div>
    )
}

export default JobExperience;